
import ItemNotFound from '@/components/common/ItemNotFound.vue'
import DataTableMixin from '@/components/mixins/DataTableMixin.vue'
import IconCSV from '@/components/svg/IconCSV.vue'
import IconExcel from '@/components/svg/IconExcel.vue'
import IconPDF from '@/components/svg/IconPDF.vue'
import IconRefresh from '@/components/svg/IconRefresh.vue'
import { LOAD_BULK_REPORT_MO_EXPORT_LIST } from '@/store/actions'
import { BARCODE_EXPORT_FORMAT } from '@/utils/constants'
import { ClickOutside } from '@/utils/directives'
import { BarcodeExportType, EBarcodePublishStatus, EExportType } from '@/utils/enums'
import errorHandler from '@/utils/errorHandler'
import { displayFileSize, isEmpty } from '@/utils/helpers'
import { IBarcodeExportResponse, IExportPaginationParams } from '@/utils/types'
import { mixins, Options } from 'vue-class-component'

@Options({
  directives: {
    clickOutside: ClickOutside,
  },
  components: { ItemNotFound, IconCSV, IconPDF, IconExcel, IconRefresh },
  emits: ['close'],
  methods: { displayFileSize },
})
export default class BulkReportMOExport extends mixins(DataTableMixin) {
  loading = false
  dataSearch = { skip: 0, count: 10, type: BarcodeExportType.BULK_REPORT_OUTPUT } as IExportPaginationParams

  currentPageNum = 1

  fileUrl = ''

  get exportRecord() {
    return this.$store.state.barcodeExport?.[EExportType.BULK_REPORT_MO]
  }

  get isHaveData(): boolean {
    return !isEmpty(this.exportRecord?.data)
  }

  isExistFile(data: IBarcodeExportResponse) {
    return data.status.toLowerCase() === EBarcodePublishStatus.COMPLETED && !isEmpty(data.fileUrl)
  }

  async onRefreshData() {
    this.loading = true
    await this.$store.dispatch(LOAD_BULK_REPORT_MO_EXPORT_LIST, this.dataSearch).finally(() => (this.loading = false))
  }

  getIcon(icon: string) {
    const iconMap: Record<string, string> = {
      [BARCODE_EXPORT_FORMAT.csv]: 'IconCSV',
      [BARCODE_EXPORT_FORMAT.pdf]: 'IconPDF',
      [BARCODE_EXPORT_FORMAT.xlsx]: 'IconExcel',
    }

    return iconMap[icon] || ''
  }

  async currentPageChange(pageNum: number) {
    this.currentPageNum = pageNum
    const skipNum = (Number(pageNum) - 1) * Number(this.dataSearch.count)
    this.dataSearch.skip = skipNum
    await this.onRefreshData()
  }

  async downloadTemplate(filePath: string) {
    try {
      this.fileUrl = filePath
      setTimeout(() => this.$refs.btnDownloadTemplate.click(), 10)
    } catch (err) {
      errorHandler(err)
    }
  }
}
